import { collectAllFields, FieldValues, Schema } from '../schema';
import { buildInitialValues } from './reducer';
import { mapConfigToForm } from './configMappers';
import { BeneathValues, beneathLayers, OwnLayer } from './layerDetail';

/**
 * What a field falls back to once this form's layer stops holding it.
 *
 * Built through the same pipeline that seeds the form, so a synthetic field lands on the mode its
 * source keys' defaults derive to rather than on an empty string.
 */
export const buildFallbackValues = (
  schema: Schema,
  isInstaller: boolean,
  ownLayer: OwnLayer | undefined,
  beneathValues: BeneathValues = {}
): FieldValues => {
  const beneath: FieldValues = {};
  for (const field of collectAllFields(schema)) {
    if (field.default !== undefined) beneath[field.id] = field.default;
    // A synthetic field's own id is not a parameter, so what it falls back to is the option its
    // parameters' defaults derive to -- and they have no control of their own to carry them.
    if (field.source_defaults) Object.assign(beneath, field.source_defaults);
  }
  // Every layer between this one and the defaults, widest first, so a cleared value lands on the
  // narrowest layer beneath that sets one rather than falling all the way through.
  if (ownLayer) {
    for (const layer of [...beneathLayers(ownLayer)].reverse()) Object.assign(beneath, beneathValues[layer] ?? {});
  }
  return buildInitialValues(schema, isInstaller ? mapConfigToForm(beneath) : beneath);
};
